import { useContext } from 'react'
import { createCtx } from '../../../context/_createCtx'
import { UserFormErrorContextValues } from '../_props'

export const defaultUserErrorValues: UserFormErrorContextValues = {
    globalErrorMessage: undefined,
}

const [ctx, provider] = createCtx(defaultUserErrorValues)

export const UserFormErrorContextProvider = provider

export const useUserFormErrorContext = () => useContext(ctx)
